"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _popover = _interopRequireDefault(require("@influitive/secret-garden/lib/popover"));

var _cardDetails = _interopRequireDefault(require("./card-details"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnstyledButton =
/*#__PURE__*/
(0, _styled.default)('button', {
  target: "el81auj0"
})("cursor:pointer;background:transparent;border:none;box-shadow:none;padding:0;width:100%;text-align:inherit;font-size:inherit;font-family:inherit;white-space:normal;display:inherit;align-items:inherit;&:hover{background-color:transparent;box-shadow:none;}");

var ProfileCard =
/*#__PURE__*/
function (_Component) {
  _inherits(ProfileCard, _Component);

  function ProfileCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProfileCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProfileCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "popoverContent", function () {
      return _react.default.createElement(_cardDetails.default, {
        profileDetails: _this.props.profileDetails,
        disableViewProfile: _this.props.disableViewProfile,
        disableMessage: _this.props.disableMessage
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderToWrapper", function () {
      return _react.default.createElement(UnstyledButton, {
        onClick: _this.props.toggleProfile,
        "data-fs": _this.props['data-fs'],
        "data-qa": _this.props['data-qa']
      }, _this.props.children);
    });

    return _this;
  }

  _createClass(ProfileCard, [{
    key: "render",
    value: function render() {
      if ((0, _lodash.default)(this.props.profileDetails)) return null;
      return _react.default.createElement(_popover.default, {
        className: "c-profile-card",
        place: this.props.position || 'below',
        onOuterAction: this.props.hideProfile,
        body: this.popoverContent(),
        isOpen: this.props.profileDetails.isOpen
      }, this.renderToWrapper());
    }
  }]);

  return ProfileCard;
}(_react.Component);

exports.default = ProfileCard;

_defineProperty(ProfileCard, "propsTypes", {
  hideProfile: _propTypes.default.func.isRequired,
  toggleProfile: _propTypes.default.func.isRequired,
  profileDetails: _propTypes.default.object.isRequired,
  disableViewProfile: _propTypes.default.bool.isRequired,
  disableMessage: _propTypes.default.bool.isRequired,
  'data-qa': _propTypes.default.string,
  'data-fs': _propTypes.default.string
});